import { RequireCapability } from "@/components/RequireCapability";

import { AdminApp } from "./components/admin/AdminApp";
import { ToolsArea } from "./components/ToolsArea";
// Registers the slice's tools.* translations (side-effect import).
import "./i18n";

/**
 * Tools directory area (route: /tools). Reached contextually from a piste
 * d'action (the Outils icon on an action-plan action); gated to any
 * authenticated user.
 */
export function ToolsPage() {
  return (
    <RequireCapability required={["authenticated"]}>
      <ToolsArea />
    </RequireCapability>
  );
}

/**
 * The CQDD tools back-office (route: /tools/admin) — list, create/edit, import.
 * Admin-gated.
 */
export function ToolsAdminPage() {
  return (
    <RequireCapability required={["expertAdmin"]}>
      <AdminApp />
    </RequireCapability>
  );
}
